module.exports = __webpack_public_path__ + "img/landscape_4-lazy.b12edce7.jpg";